import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { WarningIconCircle } from './styles';
import CustomModal from '@/components/CustomModal/CustomModal';
import theme from '@/theme';

interface DeleteModalProps {
  open: boolean;
  handleClose: () => void;
  text: string;
  confirmButtonText: string;
  onConfirm: () => void;
  title?: string;
}

const DeleteModal: FC<DeleteModalProps> = ({ open, handleClose, text, confirmButtonText, onConfirm, title }) => {
  return (
    <CustomModal open={open} handleClose={handleClose}>
      <Stack gap="1.5rem" alignItems="center">
        <WarningIconCircle>
          <WarningAmberOutlinedIcon />
        </WarningIconCircle>
        <Typography variant="h5" fontWeight="600">
          {title || 'Confirm delete'}
        </Typography>
        <Typography variant="body2" color={theme.palette.neutral.greyFont} maxWidth="724px">
          {text}
        </Typography>
        <Stack flexDirection="row" gap="1.5rem" alignSelf="end">
          <Button variant="text" color="inherit" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="error" sx={{ boxShadow: 'none' }} onClick={onConfirm}>
            {confirmButtonText}
          </Button>
        </Stack>
      </Stack>
    </CustomModal>
  );
};

export default DeleteModal;
